import script from "./ReserveTurtles.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveTurtles.vue?vue&type=script&setup=true&lang=js"

import "./ReserveTurtles.vue?vue&type=style&index=0&id=7640b89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7640b89a"]])

export default __exports__